<script setup lang="ts">
import { loadInovestorScript } from '~/helpers/scriptHelpers'

const localePath = useLocalePath()
const { t, locale } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations/shareholder-information/stock-chart',
    'fr-CA': '/relations-avec-investisseurs/section-investisseurs/graphiques-cours-action'
  }
})

useHead({
  title: t('navigation.stockChart.metatitle'),
  meta: [{ name: 'description', content: t('navigation.stockChart.metadescription') }],
  bodyAttrs: {
    class: 'stockChart'
  }
})

onMounted(() => {
  loadInovestorScript(locale.value)
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-investorRelations')">{{ $t('navigation.investorRelations.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-shareholderInformation')">{{ $t('navigation.shareholderInformation.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.stockChart.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.stockChart.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuInvestorRelations />
        <div class="contenu right">
          <div v-if="$i18n.locale == 'en-CA'"
               class="">
            <div id="container">
              <table id="quote-table">
                <caption>KP (<span id="ino_exchange_0">-</span>: <span id="ino_symbol_0">-</span>)</caption>
                <tr>
                  <td class="title">
                    Last Trade (size)
                  </td>
                  <td class="data">
                    <span id="ino_last-price_0">-</span> (<span id="ino_last-trade-size_0">-</span>)
                  </td>
                  <td class="title">
                    Open
                  </td>
                  <td class="data">
                    <span id="ino_open_0">-</span>
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    Change
                  </td>
                  <td class="data">
                    <span id="ino_change-dollar_0">-</span> - <span id="ino_change-percentage_0">-</span>
                  </td>
                  <td class="title">
                    Prev. Close
                  </td>
                  <td class="data">
                    <span id="ino_previous-close_0">-</span>
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    Volume
                  </td>
                  <td class="data">
                    <span id="ino_volume_0">-</span>
                  </td>
                  <td class="title">
                    Average Volume
                  </td>
                  <td class="data">
                    <span id="ino_average-volume_0">-</span>
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    Day's Range
                  </td>
                  <td class="data">
                    <span id="ino_daily-low_0">-</span> - <span id="ino_daily-high_0">-</span>
                  </td>
                  <td class="title">
                    52-wk Range
                  </td>
                  <td class="data">
                    <span id="ino_52wk-low_0">-</span> - <span id="ino_52wk-high_0">-</span>
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    Bid (size)
                  </td>
                  <td class="data">
                    <span id="ino_bid_0">-</span> (<span id="ino_bid-size_0">-</span>)
                  </td>
                  <td class="title">
                    Ask (size)
                  </td>
                  <td class="data">
                    <span id="ino_ask_0">-</span> (<span id="ino_ask-size_0">-</span>)
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    Last Trade Time
                  </td>
                  <td class="data">
                    <span id="ino_last-trade-time_0">-</span>
                  </td>
                  <td class="title">
                    &nbsp;
                  </td>
                  <td class="data">
                    &nbsp;
                  </td>
                </tr>
              </table>
              <div class="disclaimer">
                <p><span id="ino_delayed-info" /></p>
                <p><span id="ino_disclaimer" /></p>
              </div>
              <br><br>
              <span id="ino_chart_0" />
            </div>
          </div>
          <div v-if="$i18n.locale == 'fr-CA'"
               class="">
            <div id="container">
              <table id="quote-table">
                <caption>KP (<span id="ino_exchange_0">-</span>: <span id="ino_symbol_0">-</span>)</caption>
                <tr>
                  <td class="title">
                    Derni&egrave;re (volume)
                  </td>
                  <td class="data">
                    <span id="ino_last-price_0">-</span> (<span id="ino_last-trade-size_0">-</span>)
                  </td>
                  <td class="title">
                    Ouverture
                  </td>
                  <td class="data">
                    <span id="ino_open_0">-</span>
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    Variations
                  </td>
                  <td class="data">
                    <span id="ino_change-dollar_0">-</span> - <span id="ino_change-percentage_0">-</span>
                  </td>
                  <td class="title">
                    Fermeture - jour pr&eacute;c&eacute;dent
                  </td>
                  <td class="data">
                    <span id="ino_previous-close_0">-</span>
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    Volume
                  </td>
                  <td class="data">
                    <span id="ino_volume_0">-</span>
                  </td>
                  <td class="title">
                    Volume moyen
                  </td>
                  <td class="data">
                    <span id="ino_average-volume_0">-</span>
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    Cours quotidien
                  </td>
                  <td class="data">
                    <span id="ino_daily-low_0">-</span> - <span id="ino_daily-high_0">-</span>
                  </td>
                  <td class="title">
                    Var. 52 sem.
                  </td>
                  <td class="data">
                    <span id="ino_52wk-low_0">-</span> - <span id="ino_52wk-high_0">-</span>
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    Offre (volume)
                  </td>
                  <td class="data">
                    <span id="ino_bid_0">-</span> (<span id="ino_bid-size_0">-</span>)
                  </td>
                  <td class="title">
                    Demande (volume)
                  </td>
                  <td class="data">
                    <span id="ino_ask_0">-</span> (<span id="ino_ask-size_0">-</span>)
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    Derni&egrave;re transaction
                  </td>
                  <td class="data">
                    <span id="ino_last-trade-time_0">-</span>
                  </td>
                  <td class="title">
                    &nbsp;
                  </td>
                  <td class="data">
                    &nbsp;
                  </td>
                </tr>
              </table>
              <div class="disclaimer">
                <p><span id="ino_delayed-info" /></p>
                <p><span id="ino_disclaimer" /></p>
              </div>
              <br><br>
              <span id="ino_chart_0" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!--
  Those two classes need to be defined as they're pushed into
  ino_change-dollar_x and ino_change-percentage_x spans
-->
<style type="text/css" scoped>
.inoIrPositiveValue {
  color: green;
}

.inoIrNegativeValue {
  color: #cc0000;
}
</style>

<!-- CSS used for demo -->
<style type="text/css" scoped>
body {
  font-size: 70%;
  font-family: Verdana, Arial, Helvetica, sans-serif;
  color: #004633;
  background-color: #fff;
}

#container {
  width: 575px;
}

#quote-table {
  width: 100%;
  border-collapse: collapse;
}

#quote-table caption {
  font-weight: bold;
  text-align: left;
  background-color: #eee;
  padding: 0.3em;
}

#quote-table td {
  border-bottom: solid 1px #ddd;
  padding: 0.2em 0;
}

#quote-table td.title {
  font-weight: bold;
}

#quote-table td.data {
  text-align: right;
  padding-right: 10px;
}

.disclaimer {
  color: #999;
}
</style>
